{
  "env": "test",
  "urls": {
    "listings": "https://places.test.pinmeto.com/listings/",
    "locationPosts": "https://places.test.pinmeto.com/location-posts/",
    "accountSettings": "https://places.test.pinmeto.com/account-settings/",
    "listen": "https://places.test.pinmeto.com/listen-and-respond/",
    "cs": "https://cs.test.pinmeto.com/",
    "admin": "https://admin.test.pinmeto.com/",
    "login": "https://places.test.pinmeto.com/login/",
    "insightsApi": "https://insights.test.pinmeto.com/api/",
    "translationsUrl": "https://cdn.test.pinmeto.com/translations",
    "cdnUrl": "https://cdn.test.pinmeto.com/",
    "apiV3": "https://api.test.pinmeto.com/",
    "telemetry": "https://places.test.pinmeto.com/telemetry/"
  }
}